import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { RoleGuard } from './auth/services/role-guard.service';
import { UserRoleEnum } from './shared/enums/UserRoleEnum';
import { TenantGuard } from './shared/services/tenant-guard.service';
import { TENANT } from './shared/Tenant.enum';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'home',
    loadComponent: () => import('./home/home.component').then(m => m.HomeComponent),
    canActivate: [MsalGuard]
  },
  {
    path: 'faq/all',
    loadComponent: () => import('./faq/components/faq-all/faq-all.component').then(m => m.FaqAllComponent),
    canActivate: [MsalGuard]
  },
  {
    path: 'tenants',
    loadComponent: () => import('./tenant-independent/tenant-independent.component').then(m => m.TenantIndependentComponent),
    canActivate: [MsalGuard]
  },
  {
    path: 'help-topics',
    loadComponent: () => import('./help-topics/help-topics.component').then(m => m.HelpTopicsComponent),
    canActivate: [MsalGuard]
  },
  {
    path: 'help-topics/:help-topic',
    loadComponent: () => import('./help-topics/help-topics-subpage/help-topics-subpage.component').then(m => m.HelpTopicsSubpageComponent),
    canActivate: [MsalGuard]
  },
  {
    path: 'contact',
    loadComponent: () => import('./contact/contact.component').then(m => m.ContactComponent),
    canActivate: [MsalGuard]
  },
  {
    path: 'logout',
    loadChildren: () => import('./log-out/log-out.routes').then(m => m.default)
  },
  {
    path: 'unauthorized',
    loadComponent: () => import('./unauthorized/unauthorized.component').then(m => m.UnauthorizedComponent)
  },
  {
    path: 'admin',
    canActivate: [MsalGuard, RoleGuard],
    data: {
      rolesAllowed: [UserRoleEnum.ADMIN, UserRoleEnum.CONTENT_MANAGER] as UserRoleEnum[]
    },
    children: [
      {
        path: '',
        loadComponent: () => import('./admin/admin.component').then(m => m.AdminComponent)
      },
      {
        path: 'translations',
        loadComponent: () => import('./admin/translations/translations.component').then(m => m.TranslationsComponent)
      },
      {
        path: 'whats-new',
        loadComponent: () => import('./admin/cms-whats-new/cms-whats-new.component').then(m => m.CmsWhatsNewComponent)
      },
      {
        path: 'faqs',
        loadComponent: () => import('./admin/cms-faqs/cms-faqs.component').then(m => m.CmsFaqsComponent)
      },
      {
        path: 'help-topics',
        loadComponent: () => import('./admin/cms-help-topics/cms-help-topics.component').then(m => m.CmsHelpTopicsComponent)
      },
      {
        path: 'support-contacts',
        loadComponent: () => import('./admin/cms-support-contacts/cms-support-contacts.component').then(m => m.CmsSupportContactsComponent)
      }
    ]
  },
  {
    path: 'admin/user-management',
    loadComponent: () => import('./admin/user-management/user-management.component').then(m => m.UserManagementComponent),
    canActivate: [MsalGuard, RoleGuard, TenantGuard],
    data: {
      rolesAllowed: [UserRoleEnum.ADMIN] as UserRoleEnum[],
      tenantsAllowed: [TENANT.Siemens] as TENANT[]
    }
  }
];
